require('./bootstrap')

import Quill from 'quill'
import ImageCompress from 'quill-image-compress'
import ImageResize from 'quill-image-resize'

// Mail Antispam
let emailLinks = document.getElementsByClassName('convert-mail')
for (let link of emailLinks) {
    link.href = 'mailto:' + link.dataset.user + '@' + link.dataset.domain
    link.innerHTML = link.dataset.user + '@' + link.dataset.domain
}

// --- post fields --------------------------------------------------------------|
let contentForPageSlug = document.getElementById('content_for_page_slug')
if (contentForPageSlug) {
    hideFields(contentForPageSlug.value)
    contentForPageSlug.addEventListener('change', function () {
        hideFields(contentForPageSlug.value)
    }, false)
}

function hideFields(value) {
    const form = document.getElementById('post-form')

    const agenda = form.getElementsByClassName('agenda')
    const book_promotion = form.getElementsByClassName('boeken')
    const mix = form.getElementsByClassName('agenda_boeken')

    switch (value) {
        case 'agenda':
            for (let item of agenda) {
                item.hidden = false
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.setAttribute('required', '')
            }
            for (let item of book_promotion) {
                item.hidden = true
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.removeAttribute('required')
            }
            for (let item of mix) {
                item.hidden = false
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.setAttribute('required', '')
            }
            break
        case 'boeken':
            for (let item of book_promotion) {
                item.hidden = false
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.setAttribute('required', '')
            }
            for (let item of agenda) {
                item.hidden = true
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.removeAttribute('required')
            }
            for (let item of mix) {
                item.hidden = false
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.setAttribute('required', '')
            }
            break
        default:
            for (let item of agenda) {
                item.hidden = true
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.removeAttribute('required')
            }
            for (let item of book_promotion) {
                item.hidden = true
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.removeAttribute('required')
            }
            for (let item of mix) {
                item.hidden = true
                let input = item.querySelector('input') || item.querySelector('select')
                if (input) input.removeAttribute('required')
            }
    }
}



// --- Quill text editor --------------------------------------------------------|

Quill.register('modules/imageCompress', ImageCompress)
Quill.register('modules/imageResize', ImageResize)

const quill_container = document.getElementById('quill-editor')

if (quill_container) {
    const quill = new Quill(quill_container, {
        placeholder: 'Typ een bericht...',
        theme: 'snow',
        modules: {
            toolbar: [
                ['link', 'image']
            ],
            imageResize: {
                // See optional "config" below
            },
            imageCompress: {
                quality: 0.9,
                maxWidth: 780,
                maxHeight: 1000,
                // imageType: 'image/jpeg',
                debug: true, // default
                suppressErrorLogging: false,
            }
        },
    })
}

const form = document.querySelector('#post-form')

if (form) {
    form.onsubmit = function () {
        let quillBlank = document.querySelector('.ql-blank')
        let quillContents = document.querySelector('.ql-editor').innerHTML
        let body = document.querySelector('input[name=content]')

        if (quillBlank) {
            alert('Berichttekst moet gevuld zijn.')
            return false
        }

        body.value = JSON.stringify(quillContents)
    }
}

// --- End Quill text editor ----------------------------------------------------|
